import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var ErrorReporter = /*#__PURE__*/function () {
  function ErrorReporter() {
    _classCallCheck(this, ErrorReporter);
    _defineProperty(this, "handlerStorage", null);
  }
  return _createClass(ErrorReporter, [{
    key: "captureMessage",
    value: function captureMessage(msg, tags) {
      if (this.handlerStorage) {
        this.handlerStorage.captureMessage(msg, tags);
      }
    }
  }, {
    key: "captureException",
    value: function captureException(err, tags) {
      if (this.handlerStorage) {
        this.handlerStorage.captureException(err, tags);
      }
    }
  }, {
    key: "handler",
    set: function set(handler) {
      this.handlerStorage = handler;
    }
  }]);
}();